// client/extensions/transformers/json-string.ts
import { Transformer } from "./Transformer.js";
var jsonStringTransformer = new Transformer({
  type: "json-string",
  toContent: (value, extensions) => {
    if (value === null)
      return value;
    if (typeof value !== "string")
      throw new Error(`jsonStringTransformer expects value to be string but got ${typeof value}`);
    return JSON.parse(value);
  },
  toValue: (content) => JSON.stringify(content)
});
export {
  jsonStringTransformer
};
